export default {
  api: {
    address: {
      type: {
        notNull: "Choose an address type",
        found: "Type of address already exists",
      },
    },
  },
}
